import { ChangeDetectorRef, Component, ElementRef, Input, Renderer2 } from '@angular/core'
import { NomadeService } from '../../../../../../../nomade/services/nomade.service'
import { DialogService } from '../../../../../../../services'
import { FormDialogComponent } from '../../../dialogs/form-dialog/form-dialog.component'
import { ConfirmComponent } from '../../../../../layout/dialogs/confirm-dialog/confirm.component'

@Component({
	selector: 'atyl-nomade-dossier-formulaires',
	templateUrl: './nomade-dossier-formulaires.component.html',
	styleUrls: ['./nomade-dossier-formulaires.component.scss']
})
export class NomadeDossierFormulairesComponent {
	@Input() dossier: any;
    @Input() formulairesActionsList: any;
    @Input() urlQuickMenu: any = null;
    @Input() sortedFormsList: any = [];
	constructor(
		private nomadeService: NomadeService,
		private dialogService: DialogService,
	) { }

	ngOnInit() {
	}

    openForm(form: any) {
        console.log(form, "form")
        this.dialogService.open(FormDialogComponent, {
            data: {
                form: form,
                title: form.form.libelle,
                dossier: this.dossier
            },
            maximizable: true,
            minimizable: true,
            draggable: true,
            resizable: true,
            width: "80vw",
            height: "90vh"
        })
    }

    openNomadeForm(nomadeForm: any){
        var action = this.formulairesActionsList.find(action=>action.form.ID == nomadeForm.formId)
        if(action){
            action.form = this.setChampsFromNomadeForm(action.form,nomadeForm);
            console.log("OPEN_NOMADE",action,nomadeForm)
            this.dialogService.open(FormDialogComponent, {
                data : {
                    form: action,
                    title: nomadeForm.formLibelle,
                    dossier: this.dossier,
                    nomadeForm: nomadeForm
                },
                maximizable: true,
                minimizable: true,
                draggable: true,
                resizable: true,
                width: "80vw",
                height: "90vh"
            })

        }
    }

    setChampsFromNomadeForm(form,nomadeForm){
        var currentReq = nomadeForm.underFormsReq.find(req=>req.params.type == form.ID)
        if(currentReq){
            form.fields = currentReq.params.options.fields
        }
        if(form.under_form){
            form.under_form.forEach(f => {
                f = this.setChampsFromNomadeForm(f,nomadeForm);
            });
        }
        return form;
    } 


    deleteForm(event: Event, nomadeForm: any) {
        event.stopPropagation();
        const dialogRef = this.dialogService.open(ConfirmComponent, {
            width: '250px',
            data : {
                libelle : 'Etes-vous sur de vouloir supprimer ce formulaire ?'
            }
        });
    
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                nomadeForm.underFormsReq.forEach(request => {
                    console.log("requete supprimée", request);
                    this.nomadeService.deleteRequest(request.id);
                });
            }
        });
    }

}
